export default __webpack_public_path__ + "static/media/hourglass-top.c0848f01.svg";